import React, { memo } from 'react';
import GameWorld from '../../components/GameWorld';
import Skills from '../../components/Skills';
import Projects from '../../components/Projects';
import Contact from '../../components/Contact/Contact';
import Footer from '../../components/Footer/Footer';

const Home: React.FC = () => (
  <main className="game-page">
    <GameWorld />
    <Skills />
    <Projects />
    <Contact />
    <Footer />
  </main>
);

export default memo(Home);
